<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <i-card-vertical headerTitle="근로자 작업중지 관리" device="web" :IsUseEditorBox="true">
        <template v-slot:EditorBox>
          <date-bar
            :firstDisplayDate="startDate"
            :dateOnly="true"
            class="mx-1"
            label="조회년도"
            year
            full-width
            no-title
            @getDate="searchYearChanged"
          />
        </template>
        <template v-slot:body>
          <v-layout column>
            <DxDataGrid
              id="datagridRef"
              width="100%"
              class="layout-col-height00"
              :ref="dxDataGridRef"
              :data-source="datagrid"
              :show-borders="true"
              :show-row-lines="true"
              :column-auto-width="true"
              :allow-column-resizing="true"
              :allow-column-reordering="true"
              :focused-row-enabled="true"
              key-expr="id"
            >
              <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />
              <DxSelection
                select-all-mode="allPages"
                show-check-boxes-mode="always"
                mode="multiple"
              />
              <DxColumn
                data-field="save"
                data-type="string"
                width="120px"
                alignment="center"
                caption
                :allow-editing="false"
                cell-template="actionTemplete"
              ></DxColumn>
              <template #actionTemplete="{ data: cellInfo }">
                <div>
                  <v-btn
                    color="primary"
                    elevation="0"
                    small
                    @click="btnDetail(cellInfo)"
                    class="grid-btn rounded"
                  >상세보기</v-btn>
                </div>
              </template>
              <DxColumn
                data-field="clntId"
                data-type="string"
                alignment="left"
                caption="고객번호"
                :visible="false"
              />
              <DxColumn
                data-field="compId"
                data-type="string"
                alignment="left"
                caption="사업장번호"
                :visible="false"
              />
              <DxColumn
                data-field="writeDt"
                data-type="string"
                alignment="left"
                caption="작성일"
                :visible="false"
              />
              <DxColumn
                data-field="docNo"
                data-type="string"
                alignment="left"
                caption="문서번호"
                :visible="false"
              />
              <DxColumn
                data-field="conWriteDt"
                data-type="string"
                alignment="left"
                caption="공사등록 작성일"
                :visible="false"
              />
              <DxColumn
                data-field="conDocNo"
                data-type="string"
                alignment="left"
                caption="공사등록 문서번호"
                :visible="false"
              />
              <!--DxColumn data-field="constructNm" caption="사업장(공사)명" data-type="string" alignment="center" width="250px" :allow-editing="false" 
              css-class="devest-grid-header-require"/-->
              <DxColumn
                data-field="esgHrNoWorkStoppageNm"
                caption="요청자"
                data-type="string"
                alignment="center"
                width="100px"
                :allow-editing="false"
                css-class="devest-grid-header-require"
              />
              <DxColumn
                data-field="workStoppageDt"
                caption="요청일"
                data-type="string"
                alignment="center"
                width="120px"
                :allow-editing="false"
                css-class="devest-grid-header-require"
              />
              <DxColumn
                data-field="approvalStatus"
                caption="승인단계"
                data-type="string"
                alignment="center"
                width="100px"
                :allow-editing="false"
              >
                <DxLookup :data-source="approvalLevel" value-expr="minorCd" display-expr="minorNm" />
              </DxColumn>
              <DxColumn
                data-field="constructStatus"
                caption="사업장(공사)상태"
                data-type="string"
                alignment="center"
                width="180px"
                :allow-editing="false"
              />
              <DxColumn
                data-field="workStoppageReason"
                caption="작업중지 사유"
                data-type="string"
                alignment="left"
                :allow-editing="false"
              />
            </DxDataGrid>
          </v-layout>
        </template>
        <!-- <template v-slot:drawer>
          <v-navigation-drawer
            v-model="procedureShow"
            width="75%"
            absolute
            right
            temporary
            class="feedback-area"
          >
            <ProcedureComponent :type="'00005'"/>
          </v-navigation-drawer>
        </template>-->
      </i-card-vertical>
      <v-sheet class="iCardRightWrap">
        <i-card-right
          :useBtnList="buttonUseList"
          @btnAdd="btnAdd()"
          @btnSearch="btnSearch(true)"
          @btnDelete="btnDelete()"
        ></i-card-right>
        <!-- <i-card-right>
          <template v-slot:customBtn>
            <i-icon-button
              color="btn_text"
              :text="'절차서'"
              :icon="'file'"
              @click="procedureShow = !procedureShow"
            ></i-icon-button>
          </template>
        </i-card-right>-->
      </v-sheet>
    </v-sheet>
  </v-container>
</template>

<script>
import baseview from '@/views/base/baseview.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue'
import { getCommonCode } from '@/api/common/commonApi'
import dateBar from '@/components/common/dateBar.vue'
import { getPreMonth, getYearFormat } from '@/utils/common.js'
import { AesDecrypt } from '@/utils/aes256'
import notify from 'devextreme/ui/notify'

import { getWorkStoppages, deleteWorkStoppages } from '@/api/emergencyActionPlan/workStoppage.js'
import ProcedureComponent from '@/views/procedure/components/ProcedureComponent.vue'

export default {
  mixins: [baseview, BaseDataGrid],
  components: {
    'date-bar': dateBar,
    // 절차서 컴포넌트
    ProcedureComponent
  },
  data() {
    return {
      dxDataGridRef: 'datagridRef',
      datagrid: [],
      buttonUseList: [
        'btnSearch', //조회
        'btnDelete', //삭제
        'btnAdd' //추가
      ],
      startDate: getPreMonth(0),
      searchStartDate: getYearFormat(getPreMonth(0)),
      searchYear: '',
      initCompId: '',
      approvalLevel: [],
      // 절차서 컴포넌트
      procedureContent: '',
      procedureShow: false // 절차서 보이기
    }
  },
  created() {
    // 초기 페이지 진입 시 compId 세팅
    this.initCompId = this.getCompId()
    this.btnSearch(true)
  },
  activated() {
    if (this.$route.params?.search) {
      // 디테일 페이지에서 삭제, 추가 등 이벤트 발생 후 그리드 페이지 진입할 때
      this.btnSearch(true)
    }
    if (this.changedCompFlag(this.initCompId)) {
      // 로컬 스토리지에 저장된 값을 비교하여 변경 전 / 변경 후 compId가 다르고,
      // 페이지 진입시 세팅해두었던 compId 와 변경 후 compId와 다를 경우
      this.initCompId = this.getCompId()
      this.btnSearch(true)
    }
  },
  computed: {
    mobileTrigger: function() {
      return this.getWidth() < 1920
    }
  },
  mounted() {
    this.btnSearch(true)
    this.setCombobox()
  },
  methods: {
    btnAdd() {
      let data = {}
      Object.defineProperty(data, '__created__', {
        value: true,
        writable: true,
        enumerable: true,
        configurable: true
      })
      const toRouter = {
        name: 'WorkStoppageDetail',
        params: {
          data: data
        }
      }
      this.$router.push(toRouter)
    },
    btnSearch(isNotify) {
      this.gridInit(this.GetDataGrid(this.dxDataGridRef))

      this.openLoading('searching')
      let params = {
        clntId: this.getClntId(),
        compId: this.getCompId(),
        searchDate: this.searchStartDate
      }
      getWorkStoppages(params, isNotify).then(response => {
        if (response.success) {
          this.datagrid = response.list
        }
      })
      this.endLoading()
    },
    async btnDelete() {
      let selectedRows = await this.GetDataGrid(this.dxDataGridRef).getSelectedRowsData()
      const hasCompletedReport = selectedRows.some(el => el.approvalStatus === 'A')
      if (hasCompletedReport) {
        notify(this.$t('서명이 완료된 보고서는 삭제할 수 없습니다.'), 'error', 1000)
        return 1
      }
      if (selectedRows.length === 0) {
        this.vToastify(this.$t('selectionData'), 'info')
        return
      }
      console.log(selectedRows)

      this.vToastifyPrompt(
        this.$t('해당 항목을 삭제하시겠습니까?'),
        'info',
        current => {
          this.GetDataGrid(this.dxDataGridRef).beginUpdate()
          this.GetDataGrid(this.dxDataGridRef).saveEditData()

          this.openLoading('deleting')
          //삭제 api
          deleteWorkStoppages(selectedRows, true)
            .then(response => {
              if (response.success) {
                //
              }
            })
            .catch(error => {})
            .finally(() => {
              this.GetDataGrid(this.dxDataGridRef).endUpdate()
              this.endLoading()
              this.btnSearch(false)
            })
        },
        null,
        true
      )
    },
    btnDetail(cellInfo) {
      const toRouter = {
        name: 'WorkStoppageDetail',
        params: {
          data: cellInfo.data
        }
      }
      this.$router.push(toRouter)
    },
    searchYearChanged(year) {
      this.searchStartDate = String(year)
      this.btnSearch()
    },
    /////////////
    setCombobox() {
      Promise.all([getCommonCode('CM014')]).then(response => {
        this.approvalLevel = response[0].list
      })
    }
  }
}
</script>

<style></style>
